import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/kein_bild.jpg'


const _hoisted_1 = { class: "timi-employee-container" }
const _hoisted_2 = { class: "timi-employee-detail-content" }
const _hoisted_3 = { class: "timi-detail-column column-grow" }
const _hoisted_4 = { class: "timi-employee-profile-head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0
}
const _hoisted_7 = { class: "ww-data-list-item" }
const _hoisted_8 = { class: "ww-data-list-item" }
const _hoisted_9 = { class: "ww-data-list-item" }
const _hoisted_10 = { class: "ww-data-list-item" }
const _hoisted_11 = { class: "ww-data-list-item" }
const _hoisted_12 = { class: "ww-data-list-item" }
const _hoisted_13 = { class: "ww-data-list-item" }
const _hoisted_14 = { class: "ww-data-list-item" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "ww-data-list-item" }
const _hoisted_17 = { class: "ww-card-actions" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "ww-verticale-divider" }, null, -1)
const _hoisted_20 = { class: "timi-detail-column" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "ww-card-actions" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "ww-card-actions" }
const _hoisted_27 = { href: "/" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "ww-card-actions" }
const _hoisted_30 = { class: "timi-detail-column" }
const _hoisted_31 = { class: "list-item-small-text" }
const _hoisted_32 = { class: "list-item-small-text" }
const _hoisted_33 = { class: "list-item-small-text" }
const _hoisted_34 = { class: "list-item-small-text" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 2,
  class: "ww-card-actions"
}
const _hoisted_37 = { href: "/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          class: "timi-employee-profile",
          contentLoading: !_ctx.employee.uid
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("figure", null, [
                (_ctx.getProfileImageSrc)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getProfileImageSrc
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6))
              ]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.employee.firstName +' ' + _ctx.employee.lastName), 1)
            ]),
            _createVNode(_component_DataList, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeeNumber')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employee.number), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.siNumber')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employee.siNumber), 1)
                ]),
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('employee.personalData')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.dateOfBirth')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.dateOfBirth), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.address')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.fullAddress), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.mailPrivate')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employee.contact ? _ctx.employee.contact.email : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.telephone')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employee.contact ? _ctx.employee.contact.phone : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.employeegroup')), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.employee.group ? _ctx.employee.group.title : ''), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('label.nfcChip')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.nfcChipId')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.employee.nfcChipId), 1)
                  ])
                ]),
                (_ctx.employee.feUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('label.allowLogin')), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.loginName')), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.employee.feUser ? _ctx.employee.feUser.username : ''), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_18,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.deactivate'),
                dense: true,
                onOnClick: _ctx.handleDeactivate
              }, null, 8, ["text", "onOnClick"]),
              _hoisted_19,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleConfirmDeleteProject
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["contentLoading"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Card, {
          title: _ctx.$t('employee.departments')
        }, {
          default: _withCtx(() => [
            (_ctx.employee.departments && _ctx.employee.departments.length >0)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employee.departments, (department) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: department.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(department.title), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('emptyState.employeeDepartments')), 1))
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Card, {
          title: _ctx.$t('project.activeProjects') + (_ctx.employee && _ctx.employee.projects  && _ctx.employee.projects.length > 0 ? ' (' +   _ctx.employee.projects.length  + ')' : ''),
          contentLoading: !_ctx.employee.activeProjects
        }, {
          default: _withCtx(() => [
            (_ctx.employee && _ctx.employee.activeProjects && _ctx.employee.activeProjects.length >0)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employee.activeProjects, (project) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: project.uid,
                        class: "ww-data-list-item"
                      }, [
                        _createElementVNode("h4", null, _toDisplayString(project.getProjectTitle()), 1),
                        _createElementVNode("p", null, _toDisplayString(project?.customer?.custName), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('emptyState.projects')), 1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.onEditActiveProjects
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["title", "contentLoading"]),
        false
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "ww-card-timeTables",
              title: _ctx.$t('timeTables.title')
            }, {
              default: _withCtx(() => [
                (_ctx.timeTables && _ctx.timeTables.length >0)
                  ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeTables, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.uid,
                            class: "ww-data-list-item"
                          }, [
                            _createElementVNode("span", null, [
                              _createElementVNode("a", {
                                href: item.file
                              }, _toDisplayString(item.date), 9, _hoisted_24)
                            ]),
                            _createElementVNode("div", null, [
                              _createVNode(_component_IconButton, {
                                icon: _ctx.store.getters.svgIcons.watch,
                                onOnClick: _ctx.handleIconButtonClicked
                              }, null, 8, ["icon", "onOnClick"]),
                              _createVNode(_component_IconButton, {
                                icon: _ctx.store.getters.svgIcons.excel,
                                onOnClick: _ctx.handleIconButtonClicked
                              }, null, 8, ["icon", "onOnClick"]),
                              _createVNode(_component_IconButton, {
                                icon: _ctx.store.getters.svgIcons.pdf,
                                onOnClick: _ctx.handleIconButtonClicked
                              }, null, 8, ["icon", "onOnClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('emptyState.activities')), 1)),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.$t('button.showAll')), 1)
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              title: _ctx.$t('employee.workingTimeInfo')
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('emptyState.employeeStats')), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 2,
              title: _ctx.$t('work.title')
            }, {
              default: _withCtx(() => [
                (_ctx.employee.works && _ctx.employee.works.length >0)
                  ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employee.works, (work) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: work.uid,
                            class: "ww-data-list-item"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(work.title), 1)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('emptyState.works')), 1)),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Button, {
                    text: _ctx.$t('button.edit'),
                    dense: true,
                    onOnClick: _ctx.handleEdit
                  }, null, 8, ["text", "onOnClick"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_Card, {
          title: _ctx.$t('employee.lastActivities'),
          contentLoading: !_ctx.employee.uid
        }, {
          default: _withCtx(() => [
            (_ctx.lastActivities && _ctx.lastActivities.length > 0)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastActivities, (timeEntry) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: timeEntry.uid,
                        class: "ww-data-list-detail-item"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(timeEntry.project.title), 1),
                          false
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 0,
                                icon: _ctx.store.getters.svgIcons.watch,
                                onOnClick: _ctx.handleIconButtonClicked
                              }, null, 8, ["icon", "onOnClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.convertTimeStampToDate(timeEntry.start)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("p", _hoisted_33, _toDisplayString(timeEntry.work.title), 1),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.convertSecondsToHours(timeEntry.getTimeGone())) + " h", 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('emptyState.activities')), 1)),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$t('button.showAll')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "contentLoading"]),
        false
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              title: _ctx.$t('employee.absences')
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('emptyState.default')), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}